// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"c0a37e97","453":"43e0966c","455":"d90b7905","977":"e70b8959"}[chunkId] + ".chunk.js";
};